import lozad from 'lozad';

// gatsby-browser.js
const { observe } = lozad('[data-use-lozad]', {
  loaded: (el) => {
    el.classList.add('fade');
  },
});

export const onRouteUpdate = ({ location }) => {
  observe();
};
